<template>
    <spire-blood-result-tabs-component></spire-blood-result-tabs-component>
</template>

<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {};
    },
    watch: {},
    created() {
        this.$store.dispatch('spire/setSpireListRoute', this.listRoute);
    },
    methods: {},
};
</script>
